export function morePacks(pack) {
  return {
    hi: pack({
      how: 'कैसे चलता है',
      services: 'सेवाएँ',
      languages: 'भाषाएँ',
      findHospitals: 'अस्पताल खोजें',
      costCalculator: 'खर्च कैलकुलेटर',
      forHospitals: 'अस्पतालों के लिए',
      signIn: 'साइन इन',
      talk: 'Vani से बात करें',
      openApp: 'शुरू करें',
      seeHow: 'देखें कैसे चलता है',
      product: 'उत्पाद',
      company: 'कंपनी',
      coverage: 'क्या पूछ सकते हैं',
      pricing: 'कीमत',
      langLabel: 'भाषा',
      contact: 'संपर्क',
      privacy: 'गोपनीयता',
      terms: 'नियम',
      security: 'सुरक्षा',
      rareCancers: 'दुर्लभ कैंसर',
      teleconsultation: 'टेलीकंसल्टेशन',
      journeyBuilder: 'यात्रा योजना',
      marketplace: 'केयर मार्केटप्लेस',
      talkToVani: 'Vani से बात करें',
      talkTeam: 'टीम से बात करें',
      builtInIndia: 'भारत में बना',
      footerBlurb: 'मरीजों और परिवारों के लिए ऑन्कोलॉजी साथी, उसी भाषा में जिसमें आप सोचते हैं।',
      footerDisclaimer: 'Vani कैंसर और कैंसर देखभाल की सामान्य जानकारी देती है। वह निदान नहीं करती, दवा नहीं लिखती, और आपके ऑन्कोलॉजिस्ट की जगह नहीं लेती।',
    footerEmergency: 'अमेरिका में इमरजेंसी पर 911; संकट सहायता के लिए 988 पर कॉल या टेक्स्ट करें।',
      trainedBy: 'ऑन्कोलॉजिस्ट और स्वास्थ्य पेशेवरों द्वारा प्रशिक्षित',
      trainedOncologists: 'ऑन्कोलॉजिस्ट द्वारा प्रशिक्षित',
      heroLine1: 'कैंसर केयर के लिए',
      heroLine2: 'संपूर्ण नेविगेशन प्लेटफॉर्म।',
      heroLede: 'अपने निदान को समझें, शीर्ष कैंसर केंद्रों से जुड़ें, वास्तविक उपचार लागत की गणना करें, और अपनी मातृभाषा में 24/7 मार्गदर्शन प्राप्त करें।',
      askWriting: '{n} भाषाओं में लिखकर पूछें।',
      speakInLangs: '{n} भाषाओं में बोलें।',
      langSub: 'अमेरिकी देखभाल के लिए अंग्रेज़ी डिफ़ॉल्ट है। नीचे {n} भाषाओं में लिखें। आवाज़ आज अंग्रेज़ी, हिंदी, हिंग्लिश और मराठी में मिलती है।',
      cancerTypesCovered: 'कैंसर प्रकार कवर',
      hospitalsMapped: 'मैप किए अस्पताल',
      secondOpinions: 'विशेषज्ञ दूसरी राय',
      problemEyebrow: 'समस्या',
      problemH2: 'सवाल क्लिनिक के घंटों में नहीं आते।',
      problemP1: 'ह्यूस्टन के Memorial Hermann में मंगलवार: बीस मिनट, फिर ऑन्कोलॉजिस्ट गुरुवार तक नहीं। Sugar Land में रात 2:14 बजे बेटी गेस्ट रूम के फर्श पर पोर्टल नोट खोलकर गूगल कर रही है कि FOLFOX पर माँ क्या खाए। पहले नतीजे NHS पेज हैं।',
      problemP2: 'डॉक्टर घर जा चुके। रात के खाने का फ़ैसला, और 101 बुखार का, उसी बेटी को करना है जिसने गाड़ी चलाई।',
      problemQuote: 'इस साइकल FOLFOX चल रहा है। मैं उसे सच में क्या खिलाऊँ, और बुखार कब ER है?',
      problemAttr: 'Sugar Land, Texas. रात 2:14, Memorial Hermann पर इन्फ्यूजन के दो रात बाद।',
      howEyebrow: 'कैसे चलता है',
      howH2: 'एक सवाल लिखें। बस इतना ही इंटरफ़ेस है।',
      howSub: 'कोई फ़ॉर्म नहीं, कोई मेनू नहीं। लिखना पहले से 18 भाषाओं में चलता है।',
      howAskH: 'अपने शब्दों में पूछें',
      howAskP: 'जैसा बोलते हैं वैसा लिखें, 18 भाषाओं में। chemotherapy और platelets अंग्रेज़ी में रखें। अमेरिकी देखभाल के लिए अंग्रेज़ी डिफ़ॉल्ट है।',
      howAnswerH: 'छोटा, इंसान जैसा जवाब',
      howAnswerP: 'दो-तीन वाक्य, जैसे सामने बैठा कोई समझाए। टेक्स्ट की दीवार नहीं, चेतावनियों की लिस्ट नहीं, और कभी निदान नहीं।',
      howRememberH: 'वह याद रखती है',
      howRememberP: 'कैंसर का प्रकार, रेजिमेन, कौन सा साइकल, आपका शहर, आप मरीज हैं या बेटा। अगले हफ्ते आएँ और बात जारी रहे। माँ का निदान किसी मशीन को दो बार नहीं समझाना पड़ता।',
      langEyebrow: 'भाषाएँ',
      scopeEyebrow: 'कवरेज',
      scopeH2: 'कैंसर के प्रकार, और उसके आसपास की पूरी ज़िंदगी।',
      scopeH2n: '{n} कैंसर प्रकार, और उसके आसपास की पूरी ज़िंदगी।',
      scopeSub: 'दुर्लभ वाले भी, जहाँ परिवारों को सबसे कम मदद मिलती है और सबसे ज़्यादा चाहिए।',
      safetyEyebrow: 'सुरक्षा',
      safetyH2: 'ऐसे लोगों ने बनाया जो मानते हैं कि इसे रात 3 बजे कोई डरा हुआ इस्तेमाल करेगा।',
      priceEyebrow: 'कीमत',
      priceH2: 'अमेरिका की एक ऑन्कोलॉजी विज़िट से कम।',
      priceSub: 'प्लान $14.99 प्रति महीना से शुरू, $39.99 से घटाकर। कभी भी रद्द करें।',
      planFree: 'मुफ़्त',
      planFreeWho: 'पहले आज़माएँ',
      planFree1: '2 सवाल, कार्ड नहीं',
      planFree2: 'सभी 18 भाषाएँ',
      planFree3: 'अनुभवी ऑन्कोलॉजिस्ट से प्रशिक्षण',
      planProWho: 'मरीज और परिवार',
      planProTag: 'ज़्यादातर परिवार यही चुनते हैं',
      planPro1: '18 भाषाओं में अनलिमिटेड सवाल',
      startPro: 'PRO शुरू करें',
      planLife: 'लाइफ़टाइम',
      getLifetime: 'लाइफ़टाइम लें',
      requestDemo: 'डेमो माँगें',
      faqEyebrow: 'सवाल',
      faqH2: 'जो लोग सबसे पहले पूछते हैं।',
      faq1q: 'क्या यह ऑन्कोलॉजिस्ट की जगह लेता है?',
      faq1a: 'नहीं, और इसे ऐसा बनाया गया है कि वह बन भी न सके। Vani निदान नहीं करती, डोज़ नहीं बताती, और इलाज शुरू, रोक या बदलने को नहीं कहती। अमेरिका की क्लिनिक विज़िट के बीच के सवालों का जवाब देती है, ताकि ऑन्कोलॉजिस्ट के बीस मिनट असल काम पर लगें।',
      faq4q: 'क्या यह सिर्फ़ अंग्रेज़ी में चलती है?',
      faq4a: '18 भाषाओं में लिखकर पूछें। अमेरिका के लिए अंग्रेज़ी डिफ़ॉल्ट है।',
      faq5q: 'यह किसके लिए है?',
      faq5a: 'मरीज और देखभाल करने वाले। इन्फ्यूजन कुर्सी पर बैठा व्यक्ति, अस्पताल ले जाती बेटी, रात 2 बजे कुछ ढूँढता साथी। अगर कैंसर आपकी ज़िंदगी का हिस्सा है, यह आपके लिए है।',
      closeH2: 'गुरुवार और अगले पोर्टल मैसेज के बीच किसी को अकेला नहीं पड़ना चाहिए।',
      closeSub: 'शुरू करने के लिए एक प्लान चुनें। लगभग एक मिनट लगता है।',
      ourServices: 'हमारी सेवाएँ',
      howByonco: 'ByOnco कैसे चलता है',
      howByoncoH2: 'ByOnco कैसे चलता है',
    }),
    fr: pack({
      how: 'Comment ça marche',
      services: 'Services',
      languages: 'Langues',
      findHospitals: 'Trouver des hôpitaux',
      costCalculator: 'Calculateur de coûts',
      forHospitals: 'Pour les hôpitaux',
      signIn: 'Connexion',
      talk: 'Parler à Vani',
      openApp: 'Commencer',
      seeHow: 'Voir comment ça marche',
      product: 'Produit',
      company: 'Entreprise',
      coverage: 'Couverture',
      pricing: 'Tarifs',
      langLabel: 'Langue',
      contact: 'Contact',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      security: 'Sécurité',
      rareCancers: 'Cancers rares',
      teleconsultation: 'Téléconsultation',
      talkToVani: 'Parler à Vani',
      talkTeam: "Parler à l'équipe",
      builtInIndia: 'Conçu en Inde',
      footerBlurb: "Un compagnon d'oncologie pour les patients et les familles, dans la langue où vous pensez.",
      trainedBy: 'formée par des oncologues et des professionnels de santé',
      heroLine1: 'Des réponses sur le cancer,',
      heroLine2: 'entre les rendez-vous',
      heroLede: 'Un compagnon pour les patients atteints de cancer et les familles qui les portent. Posez vos questions sur le traitement, la nourriture, les effets secondaires, l’assurance ou simplement tenir la semaine, dans la langue où vous pensez vraiment.',
      askWriting: 'Écrivez dans {n} langues.',
      speakInLangs: 'Parlez dans n’importe laquelle des {n} langues.',
      langSub: 'L’anglais est la langue par défaut pour les soins aux États-Unis. Écrivez dans n’importe laquelle des {n} langues ci-dessous. La voix répond aujourd’hui en anglais, hindi, hinglish et marathi.',
      cancerTypesCovered: 'types de cancer couverts',
      hospitalsMapped: 'hôpitaux recensés',
      secondOpinions: 'seconds avis experts',
      problemEyebrow: 'Le problème',
      problemH2: 'Les questions n’arrivent pas pendant les heures de consultation.',
      howH2: 'Tapez une question. C’est toute l’interface.',
      howSub: 'Pas de formulaires, pas de menus. L’écrit fonctionne déjà en 18 langues.',
      priceH2: 'Moins cher qu’une seule visite d’oncologie aux États-Unis.',
      planFree: 'Gratuit',
      planFree2: 'Les 18 langues',
      startPro: 'Commencer PRO',
      faq4q: 'Est-ce que ça marche seulement en anglais ?',
      faq4a: 'Écrivez dans 18 langues. L’anglais est la langue par défaut aux États-Unis.',
      closeSub: 'Choisissez un forfait pour commencer. Cela prend environ une minute.',
      ourServices: 'Nos services',
      howByonco: 'Comment ByOnco fonctionne',
    }),
    de: pack({
      how: 'So funktioniert es',
      services: 'Leistungen',
      languages: 'Sprachen',
      findHospitals: 'Krankenhäuser finden',
      costCalculator: 'Kostenrechner',
      forHospitals: 'Für Krankenhäuser',
      signIn: 'Anmelden',
      talk: 'Mit Vani sprechen',
      openApp: 'Loslegen',
      seeHow: 'So funktioniert es',
      product: 'Produkt',
      company: 'Unternehmen',
      coverage: 'Abdeckung',
      pricing: 'Preise',
      langLabel: 'Sprache',
      talkToVani: 'Mit Vani sprechen',
      talkTeam: 'Mit dem Team sprechen',
      builtInIndia: 'Entwickelt in Indien',
      heroLine1: 'Antworten zum Krebs,',
      heroLine2: 'zwischen den Terminen',
      heroLede: 'Ein Begleiter für Krebspatientinnen, Patienten und die Familien, die sie tragen. Fragen zu Behandlung, Essen, Nebenwirkungen, Versicherung oder einfach durch die Woche, in der Sprache, in der Sie wirklich denken.',
      askWriting: 'Schreiben Sie in {n} Sprachen.',
      speakInLangs: 'Sprechen Sie in einer von {n} Sprachen.',
      langSub: 'Englisch ist die Standardprache für die Versorgung in den USA. Schreiben Sie in einer der {n} Sprachen unten. Sprache antwortet heute auf Englisch, Hindi, Hinglish und Marathi.',
      problemH2: 'Die Fragen kommen nicht in der Sprechstunde.',
      howH2: 'Tippen Sie eine Frage. Das ist die ganze Oberfläche.',
      howSub: 'Keine Formulare, keine Menüs. Schreiben funktioniert bereits in 18 Sprachen.',
      priceH2: 'Günstiger als ein einzelner onkologischer Termin in den USA.',
      planFree: 'Kostenlos',
      planFree2: 'Alle 18 Sprachen',
      faq4q: 'Geht das nur auf Englisch?',
      faq4a: 'Schreiben Sie in 18 Sprachen. Englisch ist die Standardprache für die USA.',
      closeSub: 'Wählen Sie einen Tarif, um zu beginnen. Das dauert etwa eine Minute.',
      ourServices: 'Unsere Leistungen',
    }),
    zh: pack({
      how: '使用方式',
      services: '服务',
      languages: '语言',
      findHospitals: '查找医院',
      costCalculator: '费用计算器',
      forHospitals: '医院合作',
      signIn: '登录',
      talk: '与 Vani 交谈',
      openApp: '开始使用',
      seeHow: '查看使用方式',
      product: '产品',
      company: '公司',
      coverage: '覆盖范围',
      pricing: '价格',
      langLabel: '语言',
      contact: '联系',
      privacy: '隐私',
      terms: '条款',
      security: '安全',
      rareCancers: '罕见癌症',
      talkToVani: '与 Vani 交谈',
      talkTeam: '联系团队',
      builtInIndia: '于印度打造',
      footerBlurb: '给癌症患者和家人的肿瘤科伙伴，用你真正思考时用的语言。',
      trainedBy: '由肿瘤科医生和医护人员训练',
      heroLine1: '癌症相关的回答，',
      heroLine2: '写在两次门诊之间',
      heroLede: '给癌症患者和照顾他们的家人。治疗、饮食、副作用、保险，或只是熬过这一周，用你真正思考时用的语言提问。',
      askWriting: '用 {n} 种语言书写提问。',
      speakInLangs: '用 {n} 种语言开口说。',
      langSub: '美国就医默认英语。可在下面 {n} 种语言中书写。目前语音回复支持英语、印地语、Hinglish 和马拉地语。',
      cancerTypesCovered: '覆盖的癌症类型',
      hospitalsMapped: '已收录医院',
      secondOpinions: '专家第二意见',
      problemH2: '问题不会只出现在门诊时间。',
      howH2: '输入一个问题。界面就是这样。',
      howSub: '没有表格，没有菜单。书写已支持 18 种语言。',
      priceH2: '低于美国一次肿瘤科门诊的费用。',
      planFree: '免费',
      planFree2: '全部 18 种语言',
      faq4q: '只能用英语吗？',
      faq4a: '可用 18 种语言书写。美国默认英语。',
      closeSub: '选择方案即可开始。大约一分钟。',
      ourServices: '我们的服务',
    }),
    ja: pack({
      how: '使い方',
      services: 'サービス',
      languages: '言語',
      findHospitals: '病院を探す',
      costCalculator: '費用シミュレーター',
      forHospitals: '病院の方へ',
      signIn: 'ログイン',
      talk: 'Vaniに話す',
      openApp: '始める',
      seeHow: '使い方を見る',
      product: 'プロダクト',
      company: '会社',
      coverage: 'カバー範囲',
      pricing: '料金',
      langLabel: '言語',
      talkToVani: 'Vaniに話す',
      talkTeam: 'チームに連絡',
      builtInIndia: 'インドで開発',
      heroLine1: 'がんの答えを、',
      heroLine2: '診察と診察のあいだに',
      heroLede: 'がん患者と、支える家族のための相棒です。治療、食事、副作用、保険、あるいは今週をどう乗り切るか。本当に考えている言語で聞いてください。',
      askWriting: '{n}の言語で書いて質問できます。',
      langSub: '米国のケアでは英語が初期設定です。下の{n}言語で書いてください。音声の返答は現在、英語、ヒンディー語、ヒングリッシュ、マラーティー語です。',
      howH2: '質問を入力する。それが画面のすべてです。',
      howSub: 'フォームもメニューもありません。文字での質問はすでに18言語に対応しています。',
      planFree2: '18言語すべて',
      faq4q: '英語だけですか？',
      faq4a: '18言語で書いて質問できます。米国では英語が初期設定です。',
      closeSub: 'プランを選択して開始。約1分です。',
      ourServices: 'サービス',
    }),
    ko: pack({
      how: '이용 방법',
      services: '서비스',
      languages: '언어',
      findHospitals: '병원 찾기',
      costCalculator: '비용 계산기',
      forHospitals: '병원용',
      signIn: '로그인',
      talk: 'Vani와 대화',
      openApp: '시작하기',
      seeHow: '이용 방법 보기',
      product: '제품',
      company: '회사',
      coverage: '범위',
      pricing: '요금',
      langLabel: '언어',
      talkToVani: 'Vani와 대화',
      talkTeam: '팀에 문의',
      builtInIndia: '인도에서 만듦',
      heroLine1: '암에 대한 답을,',
      heroLine2: '진료 사이에',
      heroLede: '암 환자와 그 가족을 위한 동반자입니다. 치료, 음식, 부작용, 보험, 또는 이번 주를 버티는 법을, 실제로 생각하는 언어로 물어보세요.',
      askWriting: '{n}개 언어로 글로 질문하세요.',
      howH2: '질문을 입력하세요. 그게 전부입니다.',
      howSub: '양식도 메뉴도 없습니다. 글쓰기는 이미 18개 언어로 됩니다.',
      planFree2: '18개 언어 모두',
      faq4q: '영어만 되나요?',
      faq4a: '18개 언어로 글로 질문하세요. 미국에서는 영어가 기본입니다.',
      closeSub: '플랜을 선택하고 시작하세요. 약 1분이면 됩니다.',
      ourServices: '우리 서비스',
    }),
    pt: pack({
      how: 'Como funciona',
      services: 'Serviços',
      languages: 'Idiomas',
      findHospitals: 'Encontrar hospitais',
      costCalculator: 'Calculadora de custos',
      forHospitals: 'Para hospitais',
      signIn: 'Entrar',
      talk: 'Falar com a Vani',
      openApp: 'Começar',
      seeHow: 'Ver como funciona',
      product: 'Produto',
      company: 'Empresa',
      coverage: 'Cobertura',
      pricing: 'Preços',
      langLabel: 'Idioma',
      talkToVani: 'Falar com a Vani',
      talkTeam: 'Falar com a equipe',
      builtInIndia: 'Feito na Índia',
      heroLine1: 'Respostas sobre o câncer,',
      heroLine2: 'entre as consultas',
      heroLede: 'Uma companheira para pacientes com câncer e as famílias que os sustentam. Pergunte sobre tratamento, comida, efeitos colaterais, convênio ou só como passar a semana, no idioma em que você realmente pensa.',
      askWriting: 'Escreva em {n} idiomas.',
      howH2: 'Digite uma pergunta. Essa é toda a interface.',
      howSub: 'Sem formulários, sem menus. A escrita já funciona em 18 idiomas.',
      planFree2: 'Os 18 idiomas',
      faq4q: 'Só funciona em inglês?',
      faq4a: 'Escreva em 18 idiomas. O inglês é o padrão para os EUA.',
      closeSub: 'Escolha um plano para começar. Leva cerca de um minuto.',
      ourServices: 'Nossos serviços',
    }),
    ru: pack({
      how: 'Как это работает',
      services: 'Услуги',
      languages: 'Языки',
      findHospitals: 'Найти больницы',
      costCalculator: 'Калькулятор стоимости',
      forHospitals: 'Для больниц',
      signIn: 'Войти',
      talk: 'Поговорить с Vani',
      openApp: 'Начать',
      seeHow: 'Как это работает',
      product: 'Продукт',
      company: 'Компания',
      coverage: 'Охват',
      pricing: 'Цены',
      langLabel: 'Язык',
      talkToVani: 'Поговорить с Vani',
      talkTeam: 'Связаться с командой',
      builtInIndia: 'Сделано в Индии',
      heroLine1: 'Ответы про рак,',
      heroLine2: 'между приёмами',
      heroLede: 'Спутник для пациентов с раком и семей, которые их держат. Спросите про лечение, еду, побочные эффекты, страховку или как прожить неделю, на том языке, на котором вы думаете.',
      askWriting: 'Пишите на {n} языках.',
      howH2: 'Напишите вопрос. Это весь интерфейс.',
      howSub: 'Никаких форм и меню. Письмо уже работает на 18 языках.',
      planFree2: 'Все 18 языков',
      faq4q: 'Только на английском?',
      faq4a: 'Пишите на 18 языках. Для США английский стоит по умолчанию.',
      closeSub: 'Выберите тариф, чтобы начать. Это около минуты.',
      ourServices: 'Наши услуги',
    }),
    it: pack({
      how: 'Come funziona',
      services: 'Servizi',
      languages: 'Lingue',
      findHospitals: 'Trova ospedali',
      costCalculator: 'Calcolatore dei costi',
      forHospitals: 'Per gli ospedali',
      signIn: 'Accedi',
      talk: 'Parla con Vani',
      openApp: 'Inizia',
      seeHow: 'Vedi come funziona',
      langLabel: 'Lingua',
      talkToVani: 'Parla con Vani',
      talkTeam: 'Parla con il team',
      builtInIndia: 'Realizzato in India',
      heroLine1: 'Risposte sul cancro,',
      heroLine2: 'tra una visita e l’altra',
      askWriting: 'Scrivi in {n} lingue.',
      howH2: 'Scrivi una domanda. Questa è tutta l’interfaccia.',
      howSub: 'Niente moduli, niente menu. La scrittura funziona già in 18 lingue.',
      planFree2: 'Tutte le 18 lingue',
      faq4q: 'Funziona solo in inglese?',
      faq4a: 'Scrivi in 18 lingue. L’inglese è l’impostazione predefinita per gli Stati Uniti.',
      closeSub: 'Scegli un piano per iniziare. Ci vuole circa un minuto.',
      ourServices: 'I nostri servizi',
    }),
    nl: pack({
      how: 'Hoe het werkt',
      services: 'Diensten',
      languages: 'Talen',
      findHospitals: 'Ziekenhuizen vinden',
      costCalculator: 'Kostencalculator',
      forHospitals: 'Voor ziekenhuizen',
      signIn: 'Inloggen',
      talk: 'Praat met Vani',
      openApp: 'Aan de slag',
      seeHow: 'Bekijk hoe het werkt',
      langLabel: 'Taal',
      talkToVani: 'Praat met Vani',
      talkTeam: 'Praat met het team',
      builtInIndia: 'Gemaakt in India',
      heroLine1: 'Antwoorden over kanker,',
      heroLine2: 'tussen afspraken',
      askWriting: 'Schrijf in {n} talen.',
      howH2: 'Typ een vraag. Dat is de hele interface.',
      howSub: 'Geen formulieren, geen menu’s. Schrijven werkt al in 18 talen.',
      planFree2: 'Alle 18 talen',
      faq4q: 'Werkt dit alleen in het Engels?',
      faq4a: 'Schrijf in 18 talen. Engels is de standaard voor de VS.',
      closeSub: 'Kies een abonnement om te beginnen. Het duurt ongeveer een minuut.',
      ourServices: 'Onze diensten',
    }),
    mr: pack({
      how: 'कसं चालतं',
      services: 'सेवा',
      languages: 'भाषा',
      findHospitals: 'रुग्णालय शोधा',
      costCalculator: 'खर्च मोजा',
      forHospitals: 'रुग्णालयांसाठी',
      signIn: 'साइन इन',
      talk: 'Vani शी बोला',
      openApp: 'सुरू करा',
      seeHow: 'कसं चालतं ते पहा',
      langLabel: 'भाषा',
      talkToVani: 'Vani शी बोला',
      talkTeam: 'टीमशी बोला',
      builtInIndia: 'भारतात बनवले',
      heroLine1: 'कर्करोगाची उत्तरे,',
      heroLine2: 'अपॉइंटमेंटच्या मध्ये',
      askWriting: '{n} भाषांत लिहून विचारा.',
      howH2: 'एक प्रश्न लिहा. एवढंच इंटरफेस आहे.',
      howSub: 'फॉर्म नाहीत, मेनू नाहीत. लिहिणं आधीच 18 भाषांत चालतं.',
      planFree2: 'सर्व 18 भाषा',
      faq4q: 'हे फक्त इंग्रजीत चालतं का?',
      faq4a: '18 भाषांत लिहून विचारा. अमेरिकेसाठी इंग्रजी डिफॉल्ट आहे.',
      closeSub: 'सुरू करण्यासाठी प्लॅन निवडा. सुमारे एक मिनिट लागतं.',
      ourServices: 'आमच्या सेवा',
    }),
    ta: pack({
      how: 'எப்படி வேலை செய்கிறது',
      services: 'சேவைகள்',
      languages: 'மொழிகள்',
      findHospitals: 'மருத்துவமனைகள்',
      costCalculator: 'செலவு கணிப்பான்',
      forHospitals: 'மருத்துவமனைகளுக்கு',
      signIn: 'உள்நுழை',
      talk: 'Vani-யிடம் பேசுங்கள்',
      openApp: 'தொடங்குங்கள்',
      seeHow: 'எப்படி வேலை செய்கிறது என்று பாருங்கள்',
      langLabel: 'மொழி',
      talkToVani: 'Vani-யிடம் பேசுங்கள்',
      talkTeam: 'குழுவிடம் பேசுங்கள்',
      builtInIndia: 'இந்தியாவில் உருவாக்கப்பட்டது',
      heroLine1: 'புற்றுநோய்க்கான பதில்கள்,',
      heroLine2: 'சந்திப்புகளுக்கு இடையில்',
      askWriting: '{n} மொழிகளில் எழுதிக் கேளுங்கள்.',
      howH2: 'ஒரு கேள்வியை எழுதுங்கள். அதுவே முழு இடைமுகம்.',
      howSub: 'படிவங்கள் இல்லை, மெனுக்கள் இல்லை. எழுத்து ஏற்கனவே 18 மொழிகளில் வேலை செய்கிறது.',
      planFree2: 'அனைத்து 18 மொழிகளும்',
      faq4q: 'ஆங்கிலத்தில் மட்டும்தானா?',
      faq4a: '18 மொழிகளில் எழுதிக் கேளுங்கள். அமெரிக்காவுக்கு ஆங்கிலம் இயல்புநிலை.',
      closeSub: 'தொடங்க ஒரு திட்டத்தைத் தேர்வுசெய்க. சுமார் ஒரு நிமிடம் ஆகும்.',
      ourServices: 'எங்கள் சேவைகள்',
    }),
    te: pack({
      how: 'ఎలా పనిచేస్తుంది',
      services: 'సేవలు',
      languages: 'భాషలు',
      findHospitals: 'ఆసుపత్రులు కనుగొనండి',
      costCalculator: 'ఖర్చు కాలిక్యులేటర్',
      forHospitals: 'ఆసుపత్రుల కోసం',
      signIn: 'సైన్ ఇన్',
      talk: 'Vaniతో మాట్లాడండి',
      openApp: 'ప్రారంభించండి',
      langLabel: 'భాష',
      talkToVani: 'Vaniతో మాట్లాడండి',
      builtInIndia: 'భారతదేశంలో తయారు',
      heroLine1: 'క్యాన్సర్ సమాధానాలు,',
      heroLine2: 'అపాయింట్‌మెంట్ల మధ్య',
      askWriting: '{n} భాషల్లో రాసి అడగండి.',
      howH2: 'ఒక ప్రశ్న టైప్ చేయండి. అదే మొత్తం ఇంటర్‌ఫేస్.',
      howSub: 'ఫారమ్‌లు లేవు, మెనూలు లేవు. రాయడం ఇప్పటికే 18 భాషల్లో పనిచేస్తుంది.',
      planFree2: 'అన్ని 18 భాషలు',
      faq4q: 'ఇంగ్లిష్‌లో మాత్రమేనా?',
      faq4a: '18 భాషల్లో రాసి అడగండి. అమెరికాకు ఇంగ్లిష్ డిఫాల్ట్.',
      closeSub: 'ప్రారంభించడానికి ఒక ప్లాన్‌ను ఎంచుకోండి. సుమారు ఒక నిమిషం పడుతుంది.',
      ourServices: 'మా సేవలు',
    }),
    kn: pack({
      how: 'ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ',
      services: 'ಸೇವೆಗಳು',
      languages: 'ಭಾಷೆಗಳು',
      findHospitals: 'ಆಸ್ಪತ್ರೆಗಳನ್ನು ಹುಡುಕಿ',
      costCalculator: 'ವೆಚ್ಚ ಕ್ಯಾಲ್ಕುಲೇಟರ್',
      forHospitals: 'ಆಸ್ಪತ್ರೆಗಳಿಗಾಗಿ',
      signIn: 'ಸೈನ್ ಇನ್',
      talk: 'Vani ಜೊತೆ ಮಾತನಾಡಿ',
      openApp: 'ಪ್ರಾರಂಭಿಸಿ',
      langLabel: 'ಭಾಷೆ',
      talkToVani: 'Vani ಜೊತೆ ಮಾತನಾಡಿ',
      builtInIndia: 'ಭಾರತದಲ್ಲಿ ನಿರ್ಮಿತ',
      heroLine1: 'ಕ್ಯಾನ್ಸರ್ ಉತ್ತರಗಳು,',
      heroLine2: 'ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್‌ಗಳ ನಡುವೆ',
      askWriting: '{n} ಭಾಷೆಗಳಲ್ಲಿ ಬರೆದು ಕೇಳಿ.',
      howH2: 'ಒಂದು ಪ್ರಶ್ನೆ ಟೈಪ್ ಮಾಡಿ. ಅದೇ ಇಡೀ ಇಂಟರ್‌ಫೇಸ್.',
      howSub: 'ಫಾರ್ಮ್‌ಗಳಿಲ್ಲ, ಮೆನುಗಳಿಲ್ಲ. ಬರೆಯುವುದು ಈಗಾಗಲೇ 18 ಭಾಷೆಗಳಲ್ಲಿ ಕೆಲಸ ಮಾಡುತ್ತದೆ.',
      planFree2: 'ಎಲ್ಲ 18 ಭಾಷೆಗಳು',
      faq4q: 'ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಮಾತ್ರವೇ?',
      faq4a: '18 ಭಾಷೆಗಳಲ್ಲಿ ಬರೆದು ಕೇಳಿ. ಅಮೆರಿಕಕ್ಕೆ ಇಂಗ್ಲಿಷ್ ಡಿಫಾಲ್ಟ್.',
      closeSub: 'ಪ್ರಾರಂಭಿಸಲು ಯೋಜನೆಯನ್ನು ಆರಿಸಿ. ಸುಮಾರು ಒಂದು ನಿಮಿಷ.',
      ourServices: 'ನಮ್ಮ ಸೇವೆಗಳು',
    }),
    bn: pack({
      how: 'কীভাবে কাজ করে',
      services: 'সেবা',
      languages: 'ভাষা',
      findHospitals: 'হাসপাতাল খুঁজুন',
      costCalculator: 'খরচ ক্যালকুলেটর',
      forHospitals: 'হাসপাতালের জন্য',
      signIn: 'সাইন ইন',
      talk: 'Vani-র সঙ্গে কথা বলুন',
      openApp: 'শুরু করুন',
      langLabel: 'ভাষা',
      talkToVani: 'Vani-র সঙ্গে কথা বলুন',
      builtInIndia: 'ভারতে তৈরি',
      heroLine1: 'ক্যানসারের উত্তর,',
      heroLine2: 'অ্যাপয়েন্টমেন্টের মাঝে',
      askWriting: '{n} ভাষায় লিখে জিজ্ঞাসা করুন।',
      howH2: 'একটি প্রশ্ন লিখুন। এটাই পুরো ইন্টারফেস।',
      howSub: 'কোনো ফর্ম নেই, মেনু নেই। লেখা ইতিমধ্যে ১৮ ভাষায় কাজ করে।',
      planFree2: 'সব ১৮ ভাষা',
      faq4q: 'শুধু ইংরেজিতে?',
      faq4a: '১৮ ভাষায় লিখে জিজ্ঞাসা করুন। আমেরিকার জন্য ইংরেজি ডিফল্ট।',
      closeSub: 'শুরু করতে একটি প্ল্যান বেছে নিন। প্রায় এক মিনিট লাগে।',
      ourServices: 'আমাদের সেবা',
    }),
    gu: pack({
      how: 'કેવી રીતે કામ કરે છે',
      services: 'સેવાઓ',
      languages: 'ભાષાઓ',
      findHospitals: 'હોસ્પિટલ શોધો',
      costCalculator: 'ખર્ચ કેલ્ક્યુલેટર',
      forHospitals: 'હોસ્પિટલો માટે',
      signIn: 'સાઇન ઇન',
      talk: 'Vani સાથે વાત કરો',
      openApp: 'શરૂ કરો',
      langLabel: 'ભાષા',
      talkToVani: 'Vani સાથે વાત કરો',
      builtInIndia: 'ભારતમાં બનાવેલ',
      heroLine1: 'કેન્સરના જવાબ,',
      heroLine2: 'એપોઇન્ટમેન્ટ વચ્ચે',
      askWriting: '{n} ભાષામાં લખીને પૂછો.',
      howH2: 'એક પ્રશ્ન લખો. આટલું જ ઇન્ટરફેસ છે.',
      howSub: 'ફોર્મ નથી, મેનૂ નથી. લખવું પહેલેથી 18 ભાષામાં ચાલે છે.',
      planFree2: 'બધી 18 ભાષાઓ',
      faq4q: 'ફક્ત અંગ્રેજીમાં?',
      faq4a: '18 ભાષામાં લખીને પૂછો. અમેરિકા માટે અંગ્રેજી ડિફોલ્ટ છે.',
      closeSub: 'શરૂ કરવા માટે એક પ્લાન પસંદ કરો. લગભગ એક મિનિટ લાગે છે.',
      ourServices: 'અમારી સેવાઓ',
    }),
  };
}
